import React from 'react'
import DiscountTag from './DiscountTag'
import Subtitle from '../../components/Subtitle'
import GameTags from '../game/GameTags'

export default function GameInfo(props) {
  const game = props.children || {};
  return (
    <div style={{width:'100%'}}>
      <div className="info1" style={{display:'flex',alignItems:'center'}}>
        <DiscountTag>{game}</DiscountTag>
        <div style={{flexShrink:0}}>{game?.game_classify_type?.trim()}</div>
        <Subtitle>{game.nameRemark}</Subtitle>
      </div>
    </div>
  )
}
